import React from "react";
import { PaymentsRoutesResponse } from "src/api";
import AlfredWithdrawalForm from "./AlfredWithdrawalForm";
import "./withdrawal-form.scss";

/**
 * Withdrawal entry point. The widget is bound to a single payment
 * route per session, and Alfred is the only PSP we currently render
 * here, so this component just delegates to the Alfred form. The
 * `paymentsRoutes` prop is kept for signature compatibility with the
 * page-level loader.
 */
const WithdrawalForm: React.FC<{
  paymentsRoutes: PaymentsRoutesResponse;
}> = (): JSX.Element => {
  return <AlfredWithdrawalForm />;
};

export default WithdrawalForm;
